import React, { useEffect, useState, useMemo } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { Validator } from "../widgets";
import { uuid, validateCollections, verifyObjectProperties } from "../../helpers/common";
import { useDispatch, useSelector } from "react-redux";
import { getRateTypesList, saveRateSchedules } from "../../actions/rate-schedule";
import { RATE_TYPE_LISTS } from "../../constants";
import { getUserId } from '../../helpers/session';
import DistanceIcon from '../../../assets/images/distance-icon.svg'

const RateScheduleModal = (props) => {
  const dispatch = useDispatch()
  const {
    show,
    handleClose,
    setRateList,
    isEditRateModal,
    editedData,
    farmId,
    rateList } = props;
  const [rateConfig, setRateConfig] = useState({
    rateId: null,
    rateName: "",
    rateType: "",
    rateTypeLabel: "",
    rateValue: "",
    surchargeEnabled: 'No',
    surchargeEnabledLabel: 'No',
    surchargeRateType: '',
    surchargeRateTypeLabel: '',
    surchargeRate: 0,
    visible: true,
    surChargePercentValue: 0,
    ownBedRate: 0,
    rangeMile: [{
      rangeTypeId: uuid(),
      start: 0,
      end: 0,
      ratePerRange: 0
    }]
  })

  const [isSubmited, setIsSubmited] = useState(false)
  const [errors, setErrors] = useState({});
  const [validations, setValidatons] = useState('');
  const rateTypes = useSelector((state) => state.rateSchedule.rateTypeList);
  const [rateOptions, setRateOptions] = useState([])
  // const [surChargeRateOptions, setsurChargeRateOptions] = useState([]);
  const [initialConfig, setInitialConfig] = useState({});

  const normalizeForComparison = (config) => {
    return {
      rateId: config.rateId || config.rate_uuid,
      rateName: config.rateName || config.rate_name,
      rateType: config.rateType || config.rate_type_uuid,
      rateValue: config.rateValue != null
        ? Number(config.rateValue)
        : Number(config.rate_value),
      surchargeEnabled: config.surcharge_applicable || 0,
      surchargeRateType: config.surchargeRateType || config.surcharge_type_uuid || null,
      surchargeRate: Number(
        config.surchargeRate != null
          ? config.surchargeRate
          : (config.surcharge_value != null ? config.surcharge_value : 0)
      ),
      visible: typeof config.visible === "boolean"
        ? config.visible === true ? 1 : 0
        : !!config.rate_schedule_applicable === true ? 1 : 0,
      surChargePercentValue: Number(
        config.surChargePercentValue != null
          ? config.surChargePercentValue
          : (config.additional_surcharge_percent != null
            ? config.additional_surcharge_percent
            : 0)
      ),
      ownBedRate: Number(
        config.ownBedRate != null
          ? config.ownBedRate
          : (config.own_bed_rate_value != null
            ? config.own_bed_rate_value
            : 0)
      ),
      rangeMile: (config.rangeMile || config.range_miles || []).map(r => ({
        rangeTypeId: r.rangeTypeId || r.mile_range_uuid,
        start: Number(
          r.start != null
            ? r.start
            : (r.starting_mile != null ? r.starting_mile : 0)
        ),
        end: Number(
          r.end != null
            ? r.end
            : (r.ending_mile != null ? r.ending_mile : 0)
        ),
        ratePerRange: Number(
          r.ratePerRange != null
            ? r.ratePerRange
            : (r.range_rate_value != null ? r.range_rate_value : 0)
        )
      }))
    };
  };


  useEffect(() => {
    dispatch(getRateTypesList())
  }, [])

  useEffect(() => {
    if (rateTypes && rateTypes.length > 0) {
      let rateTypeData = rateTypes.filter((e) => e.rate_type === RATE_TYPE_LISTS.RATE_TYPE).map((type) => {
        return {
          label: type.rate_type_name,
          value: type.rate_type_uuid,
        }
      })
      rateTypeData = [{
        label: 'None',
        value: 'none',
      }, ...rateTypeData];


      // const surChargeTypeData = rateTypes.filter((e) => e.rate_type === RATE_TYPE_LISTS.SURCHARGE_TYPE).map((type) => {
      //   return {
      //     label: type.rate_type_name,
      //     value: type.rate_type_uuid,
      //   }
      // })

      setRateOptions(rateTypeData)
      // setsurChargeRateOptions(surChargeTypeData)
    }
  }, [rateTypes]);

  useEffect(() => {
    if (rateConfig.rateType && rateConfig.rateType === 'none') {
      setRateConfig((prevState) => ({
        ...prevState,
        'rateValue': 0
      }));
      if (errors && errors['rateValue']) {
        let newErrors = { ...errors };
        delete newErrors['rateValue'];
        setErrors(newErrors);
      }
    }
  }, [rateConfig.rateType])

  // const rateOptions = [{ label: 'Load', value: 'Load' }, { label: 'Ton', value: 'Ton' }, { label: 'Mile', value: 'Mile' }]
  const surChargeOptions = [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }]
  // const surChargeRateOptions = [{ label: 'Mile', value: 'Mile' }, { label: 'Ton', value: 'Ton' }, { label: 'Load', value: 'Load' }]

  const preparedEditedData = {
    rateId: verifyObjectProperties(editedData, "rate_uuid"),
    rateName: verifyObjectProperties(editedData, "rate_name"),
    rateType: editedData && ((editedData.rate_type_uuid && editedData.rate_type_uuid === 'null') || !editedData.rate_type_uuid) ?
      'none' : verifyObjectProperties(editedData, "rate_type_uuid"),
    rateValue: verifyObjectProperties(editedData, "rate_value", 0),
    surchargeEnabled: verifyObjectProperties(editedData, "surcharge_applicable", "Yes"),
    surchargeRateType: verifyObjectProperties(editedData, "surcharge_type_uuid"),
    surchargeRate: verifyObjectProperties(editedData, "surcharge_value", 0),
    visible: verifyObjectProperties(editedData, "rate_schedule_applicable", false),
    surChargePercentValue: verifyObjectProperties(editedData, "additional_surcharge_percent", false),
    ownBedRate: verifyObjectProperties(editedData, "own_bed_rate_value", false),
    rangeMile: verifyObjectProperties(editedData, "range_miles", false) || rateConfig.rangeMile
  }

  const toBool = (val) => typeof val === "boolean" ? val : (val === 1 || val === "Yes") ? true : false;

  const normalizeVisible = (obj) => ({
    ...obj,
    visible: toBool(obj.visible),
    surchargeEnabled: toBool(obj.surchargeEnabled),
    surchargeEnabledLabel: toBool(obj.surchargeEnabled),
    rateValue: Number(obj.rateValue),
    ownBedRate: Number(obj.ownBedRate),
    surChargePercentValue: Number(obj.surChargePercentValue),
    rateTypeLabel: obj.rateType
  });

  const hasChanges = useMemo(() => {
    if (isEditRateModal) {
      let current = rateConfig;
      let original = normalizeForComparison(editedData);
      current = normalizeVisible(current);
      original = normalizeVisible(original);
      if (!original.rangeMile || original.rangeMile.length === 0) {
        original = {
          ...original,
          rangeMile: [{
            rangeTypeId: current.rangeMile[0].rangeTypeId,
            start: 0,
            end: 0,
            ratePerRange: 0
          }]
        };
      }

      return JSON.stringify(current) !== JSON.stringify(original);
    } else {
      const hasMainField = rateConfig.rateName.trim() !== "" ||
        rateConfig.rateType !== "" ||
        rateConfig.rateValue > 0 ||
        rateConfig.ownBedRate > 0 ||
        rateConfig.surChargePercentValue > 0;

      const hasRangeMile = rateConfig.rangeMile.some(
        rm => rm.start > 0 || rm.end > 0 || rm.ratePerRange > 0
      );

      return hasMainField || hasRangeMile;
    }
  }, [rateConfig, initialConfig, isEditRateModal]);

  const validateRateConfig = (config, field = null) => {

    const newErrors = { ...errors, rangeMile: errors.rangeMile || [] }
    const fieldsToValidate = field ? [field] : Object.keys(config);

    const isRateTypeNone = (rateConfig && rateConfig.rateType && rateConfig.rateType === 'none');

    const validationRules = {
      rateName: {
        required: true,
        message: "Rate Name is required.",
        condition: (value) => !!value,
      },
      rateType: {
        required: true,
        message: "Rate Type is required.",
        condition: (value) => !!value,
      },
      rateValue: {
        required: true,
        message: isRateTypeNone ? "Rate Value is required." : "Rate Value must be greater than 0.",
        condition: (value) =>
          (isRateTypeNone)
            ? !isNaN(parseFloat(value)) && parseFloat(value) <= 0
            : !isNaN(parseFloat(value)) && parseFloat(value) > 0
      }/* ,
      surchargeRateType: {
        required: config.surchargeEnabled === "Yes",
        message: "Surcharge Rate Type is required.",
        condition: (value) => !!value,
      },
      surchargeRate: {
        required: config.surchargeEnabled === "Yes",
        message: "Surcharge Rate must be greater than 0.",
        condition: (value) => !isNaN(parseFloat(value)) && parseFloat(value) > 0,
      }, */
    };

    fieldsToValidate.forEach((key) => {
      const rule = validationRules[key];
      if (rule) {
        if (rule.required && !rule.condition(config[key])) {
          newErrors[key] = rule.message;
        } else if (newErrors[key]) {
          delete newErrors[key];
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).filter(k => k !== 'rangeMile').length === 0;
    // return Object.keys(newErrors).length === 0;
  };

  const handleTypeChange = (e, fieldName) => {
    const value = e && (e !== null) && e.value ? e.value : '';
    const label = e && (e !== null) && e.label ? e.label : '';

    if (value !== null) {
      setRateConfig((prevState) => ({
        ...prevState,
        [fieldName]: value ? value : '',
        [`${fieldName}Label`]: label,
      }));
    } else {
      setRateConfig((prevState) => ({
        ...prevState,
        [fieldName]: '',
        [`${fieldName}Label`]: '',
      }));
    }
    if (isEditRateModal && fieldName === "surchargeEnabled") {
      setErrors({})
    }

    if (isSubmited) {
      setValidatons(fieldName)
    }
  };

  const handleInputChange = (e, key, type = "string") => {
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

    if (type === "number") {
      value = value !== "" ? value : "";
    } else if (type === "boolean") {
      value = !!value;
    }

    setRateConfig((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (isSubmited) {
      setValidatons(key)
    }
  };

  const handleCloseFun = () => {
    setIsSubmited(false)
    handleClose()
  }

  useMemo(() => {
    if (validations) {
      validateRateConfig(rateConfig, validations);
      setValidatons('')
    }
  }, [validations])

  const handleAddRangeMile = () => {
    setRateConfig(prev => ({
      ...prev,
      rangeMile: [
        ...prev.rangeMile,
        {
          rangeTypeId: uuid(),
          start: 0,
          end: 0,
          ratePerRange: 0
        }
      ]
    }));
  };

  const handleRangeMileChange = (index, field, value) => {
    const updatedRangeMile = [...rateConfig.rangeMile];
    updatedRangeMile[index][field] = Number(value);
    setRateConfig(prev => ({
      ...prev,
      rangeMile: updatedRangeMile
    }));
  };

  const handleDeleteRangeMile = (id) => {
    setRateConfig(prev => ({
      ...prev,
      rangeMile: prev.rangeMile.filter(item => item.rangeTypeId !== id)
    }));
  };

  const validateRangeMile = () => {
    const rangeMileErrors = rateConfig.rangeMile.map((item, index, array) => {
      const error = {};

      if (item.start === '' || item.start === null || item.start === 0) {
        error.start = 'Starting Mile is required';
      }
      if (item.end === '' || item.end === null || item.end === 0) {
        error.end = 'Ending Mile is required';
      } else if (item.start >= item.end) {
        error.end = 'End must be greater than Start';
      }
      if (item.ratePerRange === '' || item.ratePerRange === null || item.ratePerRange === 0) {
        error.ratePerRange = 'Rate is required';
      }

      if (index > 0) {
        const prevItem = array[index - 1];
        if (prevItem && item.start <= prevItem.end) {
          error.start = 'Start must be greater than previous End';
        }
      }

      return error;
    });

    setErrors(prev => ({
      ...prev,
      rangeMile: rangeMileErrors
    }));

    return rangeMileErrors.every(err => Object.keys(err).length === 0);
  };

  const handleSubmit = () => {
    setIsSubmited(true)
    const validation = validateRateConfig(rateConfig);
    const rangeValidation = (rateConfig.surchargeEnabled && rateConfig.surchargeEnabled === "Yes")
      ? validateRangeMile() : true;
    if (!validation || !rangeValidation) {
      return;
    }

    let rangeMiledata = rateConfig.rangeMile && rateConfig.rangeMile.length > 0 ? rateConfig.rangeMile.map((rate) => {
      return {
        mile_range_uuid: rate.rangeTypeId,
        starting_mile: rate.start,
        ending_mile: rate.end,
        range_rate_value: rate.ratePerRange,
      }
    }) : []
    let data = [];
    if (rateConfig) {

      const rateTypeId = rateConfig.rateType && rateConfig.rateType === 'none' ? null : rateConfig.rateType;
      const rateValue = rateTypeId ? parseFloat(rateConfig.rateValue) : 0;

      const object = {
        rate_uuid: isEditRateModal ? rateConfig.rateId : uuid(),
        rate_name: rateConfig.rateName,
        rate_type_uuid: rateTypeId,
        rate_value: rateValue,
        surcharge_applicable: (rateConfig.surchargeEnabled && rateConfig.surchargeEnabled === "Yes") ? 1 : 0,
        surcharge_type_uuid: rateConfig.surchargeRateType ? rateConfig.surchargeRateType : null,
        surcharge_value: parseFloat(rateConfig.surchargeRate),
        rate_schedule_applicable: rateConfig.visible ? 1 : 0,
        additional_surcharge_percent: parseFloat(rateConfig.surChargePercentValue),
        own_bed_rate_value: parseFloat(rateConfig.ownBedRate),
        range_miles: (rateConfig.surchargeEnabled && rateConfig.surchargeEnabled === "Yes") ? rangeMiledata : []
      }
      data.push(object)
    }

    if (isEditRateModal) {
      let updatedRateList = rateList && rateList.length > 0 ? validateCollections(rateList) && rateList.filter(it => it.rate_uuid !== preparedEditedData.rateId) : [];
      updatedRateList = updatedRateList.map(it => {
        return {
          ...it,
          surcharge_applicable: it.surcharge_applicable ? 1 : 0,
          rate_schedule_applicable: it.rate_schedule_applicable ? 1 : 0
        }
      })
      setRateList(() => {
        const dataList = updatedRateList && updatedRateList.length > 0 ? [...updatedRateList, ...data] : [...data];
        return dataList.sort((prev, next) => prev.rate_name.localeCompare(next.rate_name));
      });
    } else {
      let dataList = [...rateList, ...data].sort((prev, next) => prev.rate_name.localeCompare(next.rate_name));
      dataList = dataList.map(it => {
        return {
          ...it,
          surcharge_applicable: it.surcharge_applicable ? 1 : 0,
          rate_schedule_applicable: it.rate_schedule_applicable ? 1 : 0
        }
      })

      setRateList(dataList);
    }

    const removedRanges = editedData && editedData.range_miles ? editedData.range_miles
      .filter(orig => !data[0].range_miles.some(ed => ed.mile_range_uuid === orig.mile_range_uuid))
      .map(removed => ({
        ...removed,
        status_id: 2
      })) : [];

    // Merge removed ranges into edited
    const updatedEdited = data.map(item => ({
      ...item,
      range_miles: [...item.range_miles, ...removedRanges]
    }));

    const hasInvalidRangeMiles = data.some(item =>
      (item.surcharge_applicable === 1 || item.surcharge_applicable === "Yes") &&
      item.range_miles.some(
        rm => rm.starting_mile === 0 || rm.ending_mile === 0 || rm.range_rate_value === 0
      )
    );

    if (hasInvalidRangeMiles && isEditRateModal) {
      setErrors(prev => ({
        ...prev,
        general: 'Range miles cannot have 0 for start, end, or rate'
      }));
      return
    }

    const params = {
      farm_uuid: farmId,
      user_id: getUserId(),
      rate_schedule: isEditRateModal ? [...updatedEdited] : [...data]
    }
    dispatch(saveRateSchedules(params))
    handleClose();
  };

  useEffect(() => {
    if (isEditRateModal) {
      let data = preparedEditedData;
      data.surchargeEnabled = (data.surchargeEnabled === 1) ? "Yes" : "No";
      data.rangeMile = data.rangeMile && data.rangeMile.length > 0 ? data.rangeMile.map((e) => {
        return {
          rangeTypeId: e.mile_range_uuid,
          start: e.starting_mile,
          end: e.ending_mile,
          ratePerRange: e.range_rate_value
        }
      }) : rateConfig.rangeMile;

      const currentRateType = (data && data.rateType && rateOptions.length > 0)
        ? rateOptions.find((e) => e.value === data.rateType) || { label: '' }
        : { label: '' };

      setRateConfig({ ...data, "rateTypeLabel": currentRateType.label });
      setInitialConfig({ ...data, "rateTypeLabel": currentRateType.label })
    }
  }, [isEditRateModal, rateOptions]);

  return (
    <>
      <Modal show={show} onHide={handleClose} className="modal-form rate_schedule_modal" size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Rate Schedules </Modal.Title>

          <Col sm={6} md={6} lg={6} className="mt-2">
            <Form.Group className="mb-0">
              <Form.Check
                type="switch"
                id="activeInactiveToggle"
                label={rateConfig.visible ? "Active" : "Inactive"}
                checked={rateConfig.visible}
                onChange={(e) => handleInputChange(e, "visible", "boolean")}
                isInvalid={!!errors.visible}
              />
              <Form.Control.Feedback type="invalid">
                {errors.visible}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Modal.Header>
        <Modal.Body>
          <Row className="m-0">
            <Col sm={12} md={12} lg={12}>
              <Form.Group>
                <Form.Label> Rate Schedule Name <Validator.Mand /></Form.Label>
                <Form.Control
                  type="text"
                  id="rateName"
                  placeholder="Enter Rate Schedule Name"
                  value={rateConfig.rateName}
                  onChange={(e) => handleInputChange(e, "rateName", "text")}
                  isInvalid={!!errors.rateName}
                  autoComplete="off"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.rateName}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col sm={6} md={6} lg={6}>
              <Form.Group>
                <Form.Label htmlFor="rateType">Rate Type <Validator.Mand /> </Form.Label>
                <Form.Select
                  id="rateType"
                  placeholder="Select Rate Type"
                  name="rateType"
                  onChange={(e) => handleTypeChange(e, 'rateType')}
                  value={rateConfig.rateType || ''}
                  options={rateOptions}
                  className={`${((errors) && errors.rateType) ? 'is-invalid' : ''}`}
                  required
                />

                {((errors) && errors.rateType) ?
                  <small className="form-text invalid-feedback">{errors.rateType}</small> : null}
              </Form.Group>
            </Col>
            {rateConfig.rateType ? <>
              <Col sm={6} md={6} lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="rateValue"> Base Rate per {rateConfig.rateTypeLabel} USD ($)
                    <small className="error-mand ml-1">*</small></Form.Label>
                  <Form.Control
                    id="rateValue"
                    value={(rateConfig.rateValue !== "" && rateConfig.rateValue >= 0) ? rateConfig.rateValue : ''}
                    type="number"
                    onChange={(e) => handleInputChange(e, 'rateValue', 'number')}
                    placeholder={`Enter Rate per ${rateConfig.rateTypeLabel}`}
                    isInvalid={!!errors.rateValue}
                    disabled={(rateConfig && rateConfig.rateType && rateConfig.rateType === 'none')}
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors.rateValue}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </> : null}
          </Row>
          <Row className="m-0">
            <Col sm={6} md={6} lg={6}>
              <Form.Group>
                <Form.Label htmlFor="ownBedRate">Own Bed Rate USD ($)</Form.Label>
                <Form.Control
                  id="ownBedRate"
                  type="number"
                  placeholder={`Enter Own Bed Rate`}
                  value={rateConfig.ownBedRate || ''}
                  onChange={(e) => handleInputChange(e, 'ownBedRate', 'number')}
                />
              </Form.Group>
            </Col>

            <Col sm={6} md={6} lg={6}>
              <Form.Group>
                <Form.Label htmlFor="surChargePercentValue">Additional Surcharge (%) </Form.Label>
                <Form.Control
                  id="surChargePercentValue"
                  type="number"
                  min={0.01}
                  max={100}
                  placeholder={`Enter Additional Surcharge (%)`}
                  value={rateConfig.surChargePercentValue || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '' || (parseFloat(value) >= 0.001 && parseFloat(value) <= 100)) {
                      handleInputChange(e, 'surChargePercentValue', 'number');
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="custom-surcharge-container">
            <Row className="m-0">
              <Col sm={6} md={6} lg={6}>
                <Form.Group className="d-flex surcharge-checked_list align-items-center mb-0">
                  <h6 className="mr-3 mb-0">Custom Surcharge</h6>
                  <div className="d-flex">
                    {surChargeOptions.map((option) => (
                      <Form.Check
                        key={option.value}
                        type="radio"
                        id={`surchargeEnabled-${option.value}`}
                        name="surchargeEnabled"
                        className="mx-2"
                        value={option.value}
                        label={option.label}
                        checked={rateConfig.surchargeEnabled === option.value}
                        onChange={(e) => handleTypeChange(e.target, 'surchargeEnabled')}
                      />
                    ))}
                  </div>
                </Form.Group>
              </Col>
            </Row>

            {(rateConfig.surchargeEnabled === 'Yes') ? <Row className="m-0 enabled-rows">
              <Col sm={12} md={12} lg={12}>
                <div className="distance-logo-container">
                  <img src={DistanceIcon} alt="" />
                  <h6>Based on Distance</h6>
                </div>
              </Col>
              {/* <Col sm={6} md={6} lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="surchargeRateType">Surcharge Rate Type <Validator.Mand /> </Form.Label>
                  <Form.Select
                    id="surchargeRateType"
                    placeholder="Select Surcharge Type"
                    name="surchargeRateType"
                    onChange={(e) => handleTypeChange(e, 'surchargeRateType')}
                    value={rateConfig.surchargeRateType || ''}
                    options={surChargeRateOptions}
                    className={`${((errors) && errors.surchargeRateType) ? 'is-invalid' : ''}`}
                    required
                  />
                  {((errors) && errors.surchargeRateType) ?
                    <small className="form-text invalid-feedback">{errors.surchargeRateType}</small> : null}
                </Form.Group>
              </Col>
              {rateConfig.surchargeRateType ? <Col sm={6} md={6} lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="surchargeRate">Surcharge per {rateConfig.surchargeRateTypeLabel} USD ($) <Validator.Mand /> </Form.Label>
                  <Form.Control
                    id="surchargeRate"
                    type="number"
                    min={0.001}
                    placeholder={`Enter Surcharge per ${rateConfig.surchargeRateTypeLabel}`}
                    value={rateConfig.surchargeRate || ''}
                    onChange={(e) => handleInputChange(e, 'surchargeRate', 'number')}
                    isInvalid={!!errors.surchargeRate}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.surchargeRate}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col> : null} */}
              <Col sm={12} md={12} lg={12} className="px-0 distance-rate-lists">
                {rateConfig && rateConfig.rangeMile.length > 0 && rateConfig.rangeMile.map((item, index) => (
                  <Row className="m-0 mb-2 distance-mile-range" key={`${item.rangeTypeId}_${index}`}>
                    <Col sm={4} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label>Starting Mile <small className="error-mand ml-1">*</small></Form.Label>
                        <Form.Control
                          type="number"
                          value={item.start || ''}
                          onChange={(e) => handleRangeMileChange(index, 'start', e.target.value)}
                          placeholder="Enter Starting Mile"
                          isInvalid={!!(errors.rangeMile && errors.rangeMile[index] && errors.rangeMile[index].start)}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.rangeMile && errors.rangeMile[index] && errors.rangeMile[index].start}
                        </Form.Control.Feedback>

                      </Form.Group>
                    </Col>
                    <Col sm={4} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label>Ending Mile <small className="error-mand ml-1">*</small></Form.Label>
                        <Form.Control
                          type="number"
                          value={item.end || ''}
                          onChange={(e) => handleRangeMileChange(index, 'end', e.target.value)}
                          placeholder="Enter Ending Mile"
                          isInvalid={!!(errors.rangeMile && errors.rangeMile[index] && errors.rangeMile[index].end)}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.rangeMile && errors.rangeMile[index] && errors.rangeMile[index].end}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col sm={4} md={4} lg={4}>
                      <Form.Group>
                        <Form.Label>Rate USD ($) <small className="error-mand ml-1">*</small></Form.Label>
                        <Form.Control
                          type="number"
                          value={item.ratePerRange || ''}
                          onChange={(e) => handleRangeMileChange(index, 'ratePerRange', e.target.value)}
                          placeholder="Enter Rate USD ($)"
                          isInvalid={!!(errors.rangeMile && errors.rangeMile[index] && errors.rangeMile[index].ratePerRange)}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.rangeMile && errors.rangeMile[index] && errors.rangeMile[index].ratePerRange}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <div className="distance-action-btns">
                      {index === rateConfig.rangeMile.length - 1 && (
                        <button className="action-btns" onClick={handleAddRangeMile}>
                          <i className="fa fa-plus-circle text-success"></i>
                        </button>
                      )}
                      {(rateConfig.rangeMile.length > 1 && index !== 0) && (
                        <button className="action-btns" onClick={() => handleDeleteRangeMile(item.rangeTypeId)}>
                          <i
                            className="fa fa-minus-circle text-danger"
                            aria-hidden="true"
                          ></i>
                        </button>
                      )}
                    </div>
                  </Row>
                ))}

              </Col>
            </Row> : null}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseFun()}>
            Cancel
          </Button>
          <Button className={!hasChanges ? 'disabled' : ''} variant="primary" onClick={() => handleSubmit()}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RateScheduleModal;
